import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Select from "material-ui/Select";
import DialogModal from "../../common/DialogModal";
import { MenuItem } from "material-ui/Menu";
import { FormControl, FormLabel } from "material-ui/Form";
import {
  ExecSortType,
  perPageOptions,
} from "../../../constants/ComponentTypes";
import { ADDRESS_PER_PAGE } from "../../../constants/Constants";
import Button from "../../Parts/Button";

const styles = () => ({
  paper: {
    maxHeight: "unset",
    background: "#F4F6F9",
    width: "600px",
  },

  contentContainer: {
    padding: 0,
    margin: 0,
    minWidth: "600px",
  },

  innerContainer: {
    padding: "20px 25px",
    margin: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  container: {
    background: "#FFFFFF",
    border: "1px solid #D8DBDF",
    width: "100%",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    textAlign: "left",
  },

  formControl: {
    width: "100%",
    marginTop: "22px",
  },

  buttonContainer: {
    display: "inline-flex",
    width: "100%",
    justifyContent: "space-evenly",
    margin: "40px 0px 30px 0px",
  },

  selectPaper: {
    maxHeight: "unset",
  },
});

class ListSettingDialog extends React.Component {
  state = {
    sortType: ExecSortType.SORT_TYPE_RELOCATION_AT_DESC.value,
    perPage: ADDRESS_PER_PAGE,
  };

  componentWillMount() {
    this.setState({
      sortType: this.props.sortType,
      perPage: this.props.perPage,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.sortType !== nextProps.sortType) {
      this.setState({
        sortType: nextProps.sortType,
      });
    }

    if (this.props.perPage !== nextProps.perPage) {
      this.setState({
        perPage: nextProps.perPage,
      });
    }
  }

  handleChange = (property) => (e) => {
    this.setState({
      [property]: e.target.value,
    });
  };

  handleSave = () => {
    this.props.handleChangeListSetting(this.state.sortType, this.state.perPage);
    this.props.toggleDialog();
  };

  render() {
    const { classes, toggleDialog, isOpen } = this.props;

    return (
      <DialogModal
        title="表示設定"
        open={isOpen}
        onClose={toggleDialog}
        aria-labelledby="pop-up-window"
        maxWidth={false}
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer,
        }}
      >
        <div className={classes.innerContainer}>
          <div className={classes.container}>
            <FormControl
              className={classes.formControl}
              disabled={!this.props.sortType || this.props.disableSort}
            >
              <FormLabel style={{ color: "#71737B" }}>ソート順</FormLabel>
              <Select
                value={this.state.sortType}
                onChange={this.handleChange("sortType")}
                disableUnderline={true}
                MenuProps={{
                  classes: {
                    paper: classes.selectPaper,
                  },
                }}
              >
                {Object.values(this.props.sortTypes)
                  .map((item) => (
                    <MenuItem key={item.value} value={item.value}>
                      {item.text}
                    </MenuItem>
                  )
                  )}
              </Select>
            </FormControl>

            <FormControl className={classes.formControl}>
              <FormLabel style={{ color: "#71737B" }}>１ページあたりの表示件数</FormLabel>
              <Select
                value={this.state.perPage}
                onChange={this.handleChange("perPage")}
                disableUnderline={true}
                MenuProps={{
                  classes: {
                    paper: classes.selectPaper,
                  },
                }}
              >
                {Object.values(perPageOptions).map((item) => (
                  <MenuItem key={item.value} value={item.value}>
                    {item.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <div className={classes.buttonContainer}>
              <Button
                handleClickButton={this.props.toggleDialog}
                size="large"
                type="ghost"
                text="キャンセル"
                style={{ background: "transparant" }}
              ></Button>
              <Button
                handleClickButton={this.handleSave}
                size="large"
                loading={this.props.isSaving}
                text="検索"
              ></Button>
            </div>
          </div>
        </div>
      </DialogModal>
    );
  }
}

ListSettingDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  sortType: PropTypes.number,
  perPage: PropTypes.number,
  handleChangeListSetting: PropTypes.func.isRequired,
  isSaving: PropTypes.bool,
  disableSort: PropTypes.bool,
  sortTypes: PropTypes.object,
};

ListSettingDialog.defaultProps = {};

export default withStyles(styles)(ListSettingDialog);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/ListSettingDialog.jsx